import React from 'react';

const ChoiceResponse = ({ question, response, onUpdate, type }) => {
  const options = question.config?.options || [];

  const handleRadioChange = (optionValue) => {
    onUpdate(question.id, optionValue);
  };

  const handleCheckboxChange = (optionValue, checked) => {
    const currentValues = response?.value || [];
    let newValues;

    if (checked) {
      newValues = [...currentValues, optionValue];
    } else {
      newValues = currentValues.filter(value => value !== optionValue);
    }

    onUpdate(question.id, newValues);
  };

  const handleDropdownChange = (e) => {
    onUpdate(question.id, e.target.value);
  };

  if (type === 'dropdown') {
    return (
      <div>
        <select
          value={response?.value || ''}
          onChange={handleDropdownChange}
          className="form-select"
        >
          <option value="">Choose</option>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div>
      {options.map((option, index) => {
        const isChecked = type === 'radio'
          ? response?.value === option
          : (response?.value || []).includes(option);

        return (
          <div key={index} className="form-check mb-2">
            <input
              className="form-check-input"
              type={type}
              name={question.id}
              value={option}
              checked={isChecked}
              onChange={type === 'radio'
                ? () => handleRadioChange(option)
                : (e) => handleCheckboxChange(option, e.target.checked)
              }
              id={`${question.id}-${index}`}
            />
            <label className="form-check-label" htmlFor={`${question.id}-${index}`}>
              {option}
            </label>
          </div>
        );
      })}

      {type === 'checkbox' && question.config && (
        <div className="mt-2 text-muted small fst-italic">
          {question.config.minSelections > 0 && (
            <span className="me-3">
              * Select at least {question.config.minSelections} option{question.config.minSelections !== 1 ? 's' : ''}
            </span>
          )}
          {question.config.maxSelections > 0 && (
            <span>
              * Select up to {question.config.maxSelections} option{question.config.maxSelections !== 1 ? 's' : ''}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ChoiceResponse;
